export default __webpack_public_path__ + "static/media/gallery-wip-neck-grenade_03.7cf94c29.jpg";